import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { getPublicSession } from '../../publicSession/selectors';
import { attemptSocialLogin } from '../redux/actions';
import { Props } from './SocialButtonFacebook';

type StateProps = Pick<Props, 'appId'>;
type DispatchProps = Pick<Props, 'attemptSocialLogin'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = state => ({
  appId: getPublicSession(state).appIds?.facebookAppId || '',
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  attemptSocialLogin,
};

export default connect(mapStateToProps, mapDispatchToProps);
